import type React from 'react';

import { DescriptionPage_CourseType as DescriptionPageCourseType } from '__generated__/graphql-types';

import _t from 'i18n!nls/xdp';

export type ProjectInstruction = {
  icon: string;
  title: string;
  description: React.ReactNode;
};

type CourseType = (typeof DescriptionPageCourseType)[keyof typeof DescriptionPageCourseType];

function getProjectInstructions(courseType: CourseType): ProjectInstruction[] | undefined {
  switch (courseType) {
    case DescriptionPageCourseType.Project:
      return [
        {
          icon: 'KeyboardIcon',
          title: _t('Hands-on, project-based learning'),
          description: _t('Practice new skills by completing job-related tasks with step-by-step instructions.'),
        },
        {
          icon: 'CloudDownloadIcon',
          title: _t('No downloads or installation required'),
          description: _t('Access the tools and resources you need in a cloud environment.'),
        },
        {
          icon: 'AddCloudDesktopIcon',
          title: _t('Available only on desktop'),
          description: _t(
            'This project is designed for laptops or desktop computers with a reliable Internet connection, not mobile devices.'
          ),
        },
      ];
    case DescriptionPageCourseType.RhymeProject:
      return [
        {
          icon: 'KeyboardIcon',
          title: _t('Skill-based, hands-on learning'),
          description: _t('Practice new skills by completing job-related tasks.'),
        },
        {
          icon: 'TeacherIcon',
          title: _t('Expert guidance'),
          description: _t('Follow along with pre-recorded videos from experts using a unique side-by-side interface.'),
        },
        {
          icon: 'CloudDownloadIcon',
          title: _t('No downloads or installation required'),
          description: _t('Access the tools and resources you need in a pre-configured cloud workspace.'),
        },
        {
          icon: 'AddCloudDesktopIcon',
          title: _t('Available only on desktop'),
          description: _t(
            'This Guided Project is designed for laptops or desktop computers with a reliable Internet connection, not mobile devices.'
          ),
        },
      ];
    default:
      return undefined;
  }
}

export default getProjectInstructions;
